export default __webpack_public_path__ + "static/media/roadmap-m-6.af5b3652.png";